import type { BoundingRect } from '@shopify/polaris-viz-core';

export {
  BASE_ANIMATION_DURATION,
  XMLNS,
  LOAD_ANIMATION_DURATION,
  SHAPE_ANIMATION_HEIGHT_BUFFER,
  DEFAULT_BORDER_RADIUS,
  HORIZONTAL_BAR_LABEL_HEIGHT,
  HORIZONTAL_BAR_LABEL_OFFSET,
  HORIZONTAL_GROUP_LABEL_HEIGHT,
  HORIZONTAL_SPACE_BETWEEN_SETS,
  HORIZONTAL_SPACE_BETWEEN_SINGLE,
  HORIZONTAL_SPACE_BETWEEN_CHART_AND_AXIS,
  LINE_ANIMATION_FAST_DURATION,
  LINE_ANIMATION_SLOW_DURATION,
  LINE_ANIMATION_FAST_COUNT,
  LINE_ANIMATION_DURATION_STEP,
  FONT_SIZE,
  LINE_HEIGHT,
  SMALL_CHART_HEIGHT,
  DEFAULT_MAX_Y,
  MIN_BAR_HEIGHT,
  EMPTY_STATE_CHART_MIN,
  EMPTY_STATE_CHART_MAX,
  ChartMargin,
  BARS_TRANSITION_CONFIG,
  BARS_SORT_TRANSITION_CONFIG,
  BARS_LOAD_ANIMATION_CONFIG,
  LINES_LOAD_ANIMATION_CONFIG,
  MASK_HIGHLIGHT_COLOR,
  DARK_THEME,
  LIGHT_THEME,
  PRINT_THEME,
  STACKED_BAR_GAP,
  LABEL_AREA_TOP_SPACING,
  LABEL_AREA_MIN_SPACING,
  HORIZONTAL_LABEL_MIN_WIDTH,
  ELLIPSIS,
  MAX_DIAGONAL_LABEL_WIDTH,
  MAX_DIAGONAL_VISIBLE_HEIGHT,
  VERTICAL_LABEL_TARGET_WIDTH,
  DIAGONAL_LABEL_MIN_WIDTH,
  HORIZONTAL_LABEL_TARGET_HEIGHT,
  VERTICAL_LABEL_MIN_WIDTH,
  Y_AXIS_CHART_SPACING,
} from '@shopify/polaris-viz-core';

export const DEFAULT_LEGEND_HEIGHT = 24;
export const DEFAULT_LEGEND_WIDTH = 29;
export const BAR_CONTAINER_TEXT_HEIGHT = 48;
export const ANNOTATIONS_LABELS_OFFSET = 10;
export const Y_AXIS_LABEL_OFFSET = 2;
export const TOOLTIP_BG_OPACITY = 0.8;
export const PREVIEW_ICON_SIZE = 12;
export const DASHED_LINE_PREVIEW_STROKE_DASHARRAY = '1.5 3';
export const ARC_PAD_ANGLE = 0.02;
export const ZERO_VALUE_LINE_HEIGHT = 6;
export const NEGATIVE_ZERO_LINE_OFFSET = 10;
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_TEST = process.env.NODE_ENV === 'test';
export const WARN_FOR_DEVELOPMENT = IS_DEVELOPMENT && !IS_TEST;
export const HOVER_TARGET_ZONE = 48;
export const CROSSHAIR_ID = 'Crosshair';
export const DEFAULT_ANIMATION_DELAY = 100;
export const TOOLTIP_ID = 'polaris_viz_tooltip_root';
export const EMPTY_BOUNDS: BoundingRect = {
  width: 0,
  height: 0,
  x: 0,
  y: 0,
};
